import { connect } from "dva";
import { createForm } from "rc-form";
import { CompanyManagement } from "./CompanyManagement";
import { routerRedux } from "dva/router";

const fetchActionURL = "users/getAllCompanies";
export const mapStateToProps = (state, ownProps) => {  
  const {
    loading,
    users: { companyTotal, companyList, createCompanyModal, deleteCompanyModal, switchCompanyModal },
  } = state;

  const isLoading = loading.effects[fetchActionURL];
  return {
    fetchActionURL,
    companyList,
    companyTotal,
    isLoading,
    createCompanyModal,
    deleteCompanyModal,
    switchCompanyModal
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname) {
      dispatch(routerRedux.push({ pathname: `${pathname}` }));
    },
    getAllCompanies(data) {
      dispatch({ type: fetchActionURL, payload: data });
    },
    getSingleCompany(data){
      dispatch({ type: "users/getSingleCompany", payload: data });
    },
    openDeleteModal() {
      dispatch({ type: "users/save", payload: { deleteCompanyModal: true } });
    },

    openCreateModal() {
      dispatch({ type: "users/save", payload: { createCompanyModal: true } });
    },
    openSwitchModal() {
      dispatch({ type: "users/save", payload: { switchCompanyModal: true } });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(createForm()(CompanyManagement));
